// Translations
import message from '../sections/message/translations/de'

// Translation: Error > Landing (German)
export default Object.freeze({
	sections: { message }
})
